import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from './mediaplaceholder.style';

// Visible stand-in for CloudPouch 2.0 media that does not exist yet.
// Do not ship it: replace every use with the final file from
// wi/WI-008/VIDEO-SCREENS-PLAN-v2.md (naming: section 5.3). Old 1.x screens and
// videos must not be presented as 2.0.
const MediaPlaceholder = ({ kind, file, label, ratio }) => (
  <Placeholder $ratio={ratio} role="img" aria-label={`Placeholder: ${label}`}>
    <strong>PLACEHOLDER</strong>
    <span>{label}</span>
    <code>{file}</code>
  </Placeholder>
);

MediaPlaceholder.propTypes = {
  kind: PropTypes.oneOf(['video', 'screen']),
  file: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  ratio: PropTypes.string,
};

MediaPlaceholder.defaultProps = {
  kind: 'screen',
  ratio: '16 / 9',
};

export default MediaPlaceholder;
